/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OnboardingInfoDesktop/view.blocks to change it.
import BellIcon from 'DesignSystem/Svgs/BellIcon/index'
import CalendarIcon from 'DesignSystem/Svgs/CalendarIcon/index'
import DollarIcon from 'DesignSystem/Svgs/DollarIcon/index'
import OnboardingCard from 'DesignSystem/OnboardingCard/index'
import OnboardingDots from 'DesignSystem/Images/OnboardingDots/index'
import OnboardingSusyRon from 'DesignSystem/Images/OnboardingSusyRon/index'
import ProfileIcon from 'DesignSystem/Svgs/ProfileIcon/index'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function OnboardingInfoDesktop({
  children,
  viewPath = "/DesignSystem/OnboardingInfoDesktop"
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="OnboardingInfoDesktop.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-23mxv': isBefore ? 0 : 1,'--tx-2-23mxv': isBefore ? "50%" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="OnboardingInfoDesktop.Vertical:1"
  data-view-path={viewPath}
 style={{'--o-1-23mxv': isBefore ? 0 : 1,'--l-3-23mxv': isBefore ? "20%" : "28%"}}
 className={`views-block ${styles.Vertical1}`}
>
<OnboardingDots
  viewPath={`${viewPath}/OnboardingDots`}
 width={73}
 height={266}
/>
</div>
<div
  data-testid="OnboardingInfoDesktop.Vertical:2"
  data-view-path={viewPath}
 style={{'--o-1-23mxv': isBefore ? 0 : 1,'--l-3-23mxv': isBefore ? "28%" : "35%"}}
 className={`views-block ${styles.Vertical2}`}
>
<OnboardingDots
  viewPath={`${viewPath}/OnboardingDots`}
 width={73}
 height={266}
/>
</div>
<div
  data-testid="OnboardingInfoDesktop.Vertical:3"
  data-view-path={viewPath}
 style={{'--o-1-23mxv': isBefore ? 0 : 1,'--l-3-23mxv': isBefore ? "36%" : "42%"}}
 className={`views-block ${styles.Vertical3}`}
>
<OnboardingDots
  viewPath={`${viewPath}/OnboardingDots`}
 width={73}
 height={266}
/>
</div>
<div
  data-testid="OnboardingInfoDesktop.Vertical:4"
  data-view-path={viewPath}
 style={{'--tx-2-23mxv': isBefore ? "50px" : "-30px"}}
 className={`views-block ${styles.Vertical4}`}
>
<OnboardingSusyRon
  viewPath={`${viewPath}/OnboardingSusyRon`}
 height={504}
 width={632}
/>
</div>
<div
  data-testid="OnboardingInfoDesktop.Vertical:5"
  data-view-path={viewPath}
 style={{'--o-1-23mxv': isBefore ? 0 : 1,'--t-4-23mxv': isBefore ? "20%" : "22%"}}
 className={`views-block ${styles.Vertical5}`}
>
<OnboardingCard
  viewPath={`${viewPath}/OnboardingCard`}
 text="View, Schedule and Reschedule Appointments"
>
{childProps => (
<CalendarIcon
{...childProps}
  viewPath={`${viewPath}/CalendarIcon`}
 width={25}
 height={25}
 stroke="rgba(0,188,112, 1)"
/>
)}
</OnboardingCard>
</div>
<div
  data-testid="OnboardingInfoDesktop.Vertical:6"
  data-view-path={viewPath}
 style={{'--o-1-23mxv': isBefore ? 0 : 1,'--t-4-23mxv': isBefore ? "30%" : "32%"}}
 className={`views-block ${styles.Vertical6}`}
>
<OnboardingCard
  viewPath={`${viewPath}/OnboardingCard`}
 text="Update your Demographic and Health History"
>
{childProps => (
<ProfileIcon
{...childProps}
  viewPath={`${viewPath}/ProfileIcon`}
 width={25}
 height={25}
 stroke="rgba(0,188,112, 1)"
/>
)}
</OnboardingCard>
</div>
<div
  data-testid="OnboardingInfoDesktop.Vertical:7"
  data-view-path={viewPath}
 style={{'--o-1-23mxv': isBefore ? 0 : 1,'--t-4-23mxv': isBefore ? "40%" : "42%"}}
 className={`views-block ${styles.Vertical7}`}
>
<OnboardingCard
  viewPath={`${viewPath}/OnboardingCard`}
 text="Print and Download HSA/FSA Receipts"
>
{childProps => (
<DollarIcon
{...childProps}
  viewPath={`${viewPath}/DollarIcon`}
 width={25}
 height={25}
 stroke="rgba(0,188,112, 1)"
/>
)}
</OnboardingCard>
</div>
<div
  data-testid="OnboardingInfoDesktop.Vertical:8"
  data-view-path={viewPath}
 style={{'--o-1-23mxv': isBefore ? 0 : 1,'--t-4-23mxv': isBefore ? "50%" : "52%"}}
 className={`views-block ${styles.Vertical8}`}
>
<OnboardingCard
  viewPath={`${viewPath}/OnboardingCard`}
 text="View and Pay Your Account Balance"
>
{childProps => (
<BellIcon
{...childProps}
  viewPath={`${viewPath}/BellIcon`}
 width={25}
 height={25}
 stroke="rgba(0,188,112, 1)"
/>
)}
</OnboardingCard>
</div>
</div>
{children}
</React.Fragment>)
}